<button *ngIf="printerIsConnected && !printerIsIgnored" class="experiment_green" (click)="connect()"> {{ textBtnPrint }}</button>
<button *ngIf="!printerIsConnected && !printerIsIgnored" class="experiment" (click)="connect()"> {{ textBtnPrint }}</button>
<button *ngIf="printerIsIgnored" class="experiment_orange" (click)="connect()"> {{ textBtnPrint }}</button>
